import type { TradeDirection } from '../types'

/**
 * Why a trade's stop loss / take profit can't be logged, or null if they can.
 * A LONG's take profit sits above entry and its stop below; a SHORT mirrors it.
 * Mirrors TrackRecordService._validate_levels so the form catches it first.
 */
export const tradeLevelError = (
  direction: TradeDirection,
  entryPrice: number,
  stopLoss?: number,
  takeProfit?: number
): string | null => {
  if (direction === 'LONG') {
    if (takeProfit != null && takeProfit <= entryPrice) {
      return 'For a LONG, take profit must be above the entry price'
    }
    if (stopLoss != null && stopLoss >= entryPrice) {
      return 'For a LONG, stop loss must be below the entry price'
    }
  } else {
    if (takeProfit != null && takeProfit >= entryPrice) {
      return 'For a SHORT, take profit must be below the entry price'
    }
    if (stopLoss != null && stopLoss <= entryPrice) {
      return 'For a SHORT, stop loss must be above the entry price'
    }
  }
  return null
}
